import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class TodoTypeRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/prodorders/todo/types');
    }

    async getAll() {
        if (Cache.get('todotypes')) {
            return Cache.get('todotypes');
        }

        return this.where('per_page', 1000).run().then((res) => {
            Cache.set('todotypes', res);
            return Cache.get('todotypes');
        });
    }
}
